<template>
  <div class="intervention">
    <h2>Coming soon!</h2>
  </div>
</template>

<script>
export default {
  name: 'Intervention'
};
</script>

<style scoped>
.intervention {
  padding: 40 60px;
  color: black;
  font-size: 20px;
}
</style>
